export const testIds = {
  PageFormRoot: 'PageForm_Root',
  PageFormInput: 'PagForm_Input',
  PageFormTotalPages: 'PageForm_TotalPages',
};
